module.exports = __webpack_public_path__ + "static/media/business_buildings_art.3387dcf4.jpg";